const $ = require('jquery')
const toastr = require('toastr')
const Vue = require('vue')
const R = require('ramda')

Vue.component('form-textarea', {
    name: 'form-textarea',
    props: {
        label: {
            type: String
        },
        placeholder: {
            type: String
        },
        tooltip: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        rows: {
            type: String
        },
        cols: {
            type: String
        },
        model: {
            twoWay: true,
            default: null
        },
        name: {
            default: null
        },
        maxLength: {
            type: Number
        },
        validateUrls: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        holderClass () {
            return this.iconClass ? 'input-icon' : null
        },
        focus () {
            this.$els.input.focus()
        }
    },
    data () {
        return {
            fieldName: ''
        }
    },
    ready () {
        this.fieldName = this.name || this._props.model.raw

        if (!this.placeholder) {
            this.placeholder = this.label
        }

        if (this.validateUrls) {
            $(this.$els.input).on('blur', () => {
                const input = this.$els.input
                const value = input.value
                if (value.includes('http://')) {
                    let invalids = Array.from(value.matchAll(/(\bhttp:\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig)).map((match) => {
                        return `<div>- ${match[1]}</div>`
                    })

                    invalids = R.uniq(invalids).join('\n')

                    toastr.warning(`
                        <div>Você inseriu URLs sem https e isso pode prejudicar o nível de segurança do seu site. Recomendamos que dê preferência para URLs com o protocolo https!</div>
                        <div><b>Links:</b></div>
                        ${invalids}
                        <div style="margin-top: 10px">
                            <button class="btn default btn-sm go-to-field">ir para o campo</button>
                        </div>
                    `, 'Cuidado!', {
                        timeOut: 0,
                        onShown: function () {
                            $(this).find('.go-to-field').on('click', function () {
                                input.focus()
                                $.scrollTo(input, {
                                    offset: -75,
                                    animate: true
                                })
                            })
                        },
                        preventDuplicates: true
                    }).width(300)
                }
            })
        }

        if (this.maxLength) {
            $(this.$els.input).attr('maxlength', this.maxLength)
            $(this.$els.input).maxlength({
                alwaysShow: true,
                warningClass: 'label label-primary',
                limitReachedClass: 'label label-danger',
                separator: ' de ',
                preText: '',
                postText: ' ',
                validate: true
            })
        }
    },
    template: `
            <div class="form-group">
                <label v-if="label">
                    {{ label }}
                    <i v-if="tooltip" class="fa fa-info-circle" v-tooltip :title="tooltip"></i>
                </label>
                <textarea
                    v-el:input
                    class="form-control"
                    v-bind:placeholder="placeholder"
                    v-bind:disabled='disabled'
                    v-model="model"
                    v-bind:rows="rows"
                    v-bind:cols="cols"
                    v-bind:data-field="fieldName"
                    style="resize: none;"></textarea>
                <form-errors :fields="[fieldName]" :on-error="focus"></form-errors>
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/textarea.js